export const children_diseases = [
    {"children_disease_id":"1","disease_name":"Malaria","disease_name_swahili":"Malaria"},
    {"children_disease_id":"2","disease_name":"Diarrhea","disease_name_swahili":"Kuharisha"},
    {"children_disease_id":"3","disease_name":"Vomiting","disease_name_swahili":"Kutapika"},
    {"children_disease_id":"4","disease_name":"Fever","disease_name_swahili":"Homa"},
    {"children_disease_id":"5","disease_name":"Food Allergies","disease_name_swahili":"Alegi ya chakula"},
    {"children_disease_id":"6","disease_name":"HIV","disease_name_swahili":"UKIMWI"},
    {"children_disease_id":"7","disease_name":"Pneumonia","disease_name_swahili":"Nimonia"},
    {"children_disease_id":"8","disease_name":"Tuberculosis (TB)","disease_name_swahili":"Kifua kikuu (TB)"}
];